const menuItems = [
  // General
  {
    id: "dashboard",
    label: "dashboard",
    rightName: "dashboard",
    icon: "mdi mdi-chart-box-outline",
    link: "/dashboard",
    badge: 3,
    badgeColor: "bg-primary",
  },
  {
    id: "projects",
    label: "projects",
    rightName: "project",
    icon: "mdi mdi-folder-multiple-outline",
    link: "/projects",
    badge: 3,
    badgeColor: "bg-primary",
  },
  {
    id: "configurations",
    label: "configurations",
    rightName: "configuration",
    icon: "mdi mdi-lightning-bolt",
    link: "/configurations",
    badge: 3,
    badgeColor: "bg-primary",
  },
  {
    id: "catalog",
    label: "catalog",
    rightName: "catalog",
    icon: "bx bx-shopping-bag",
    link: "/catalogs"
  },
  {
    id: "sectors", 
    label: "sectors", 
    rightName: "sector",
    icon: "mdi mdi-hubspot", 
    link: "/sectors",
  },
  {
    id: "agencies", 
    label: "agencies", 
    rightName: "agency",
    icon: "mdi mdi-office-building-marker", 
    link: "/agencies",
  },
  {
    id: "departments", 
    label: "departments", 
    rightName: "department",
    icon: "mdi mdi-focus-field", 
    link: "/departments",
  },
  {
    id: "users", 
    label: "users", 
    rightName: "user",
    icon: "mdi mdi-account", 
    link: "/users",
  },
];

export default menuItems;